<template>
  <SummaryCard
    :title="$t('views.portfolio.topPortfoliototalPl.title')"
    :infoText="$t('views.portfolio.topPortfoliototalPl.info')"
    :loading="loadingSummary"
    :value="plBaseCurrency"
    :valueCurrency="user.baseCurrency"
    :comparisonPercent="plBaseCurrencyPercent"
    valueShowPositive
    valuePositiveGreen
  />
</template>

<script>
import { get } from 'lodash'
import { mapState } from 'vuex'
import SummaryCard from '@/views/components/dashboardDetail/summary/SummaryCard'

export default {
  components: { SummaryCard },
  props: {
    summary: {
      type: Object,
      default: () => {},
    },
    loadingSummary: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    ...mapState(['user']),
    plBaseCurrency() {
      return get(this.summary, 'plBaseCurrency', null)
    },
    plBaseCurrencyPercent() {
      return get(this.summary, 'plBaseCurrencyPercent', null)
    },
  },
}
</script>
